import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { useInitialFetch } from 'core/context/initialFetchContext';
import { transformPlaceholder } from 'core/utils/stringUtils';
import './search-form-arctectum.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import { all_routes } from 'core/data/routes/all_routes';

const SearchForm = () => {
    const [selectedOptions, setSelectedOptions] = useState({});
    const { homeMainCategories: categoriesData } = useInitialFetch();
    const routes = all_routes;

    const handleSelectChange = (e, optionType) => {
        setSelectedOptions({ ...selectedOptions, [optionType]: e.value });
    };

    const buildQueryParams = () => {
        const params = new URLSearchParams();
        if (categoriesData) {
            categoriesData.forEach(category => {
                const selectedValue = selectedOptions[category.id];
                if (selectedValue) {
                    params.append(category.filter.name, selectedValue);
                }
            });
        }
        return params.toString();
    };

    const placeholders = ['', '', ''];

    return (
        <div className="ltn__car-dealer-form-area section-bg-1--- mt-20 pb-115---" style={{ marginBottom: '-100px' }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ltn__car-dealer-form-tab">
                            <div className="tab-content bg-white box-shadow-1 position-relative pb-10 improved-tab-content" style={{ paddingTop: '18px' }}>
                                <div className="tab-pane fade active show" id="ltn__form_tab_1_1">
                                    <div className="car-dealer-form-inner improved-form-inner">
                                        <h2 className="form-title text-center mb-4">Selecciona fácilmente y descubre el acabado perfecto</h2> {/* Moved title */}
                                        <form action="#" className="ltn__car-dealer-form-box row improved-form-box">
                                            {/* <h6 className="section-title" style={{ fontSize: '25px' }}>Filtra y Construye</h6> */}
                                            {placeholders.map((placeholder, index) => {
                                                const category = categoriesData ? categoriesData[index] : null;
                                                return (
                                                    <div key={index} className="ltn__car-dealer-form-item ltn__custom-icon---- ltn__icon-car---- col-lg-3 col-md-6 col-10 mx-auto improved-form-item">
                                                        <Dropdown
                                                            value={selectedOptions[category?.id]}
                                                            options={category ? category.values.map(value => ({ label: transformPlaceholder(value.value), value: value.value })) : []}
                                                            onChange={(e) => handleSelectChange(e, category?.id)}
                                                            placeholder={category ? transformPlaceholder(category.filter.name === "home_category" ? 'aplicación' : category.filter.name) : placeholder}
                                                            className="improved-select"
                                                        />
                                                    </div>
                                                );
                                            })}
                                            <div className="ltn__car-dealer-form-item ltn__custom-icon ltn__icon-calendar col-lg-3 col-md-6 improved-form-item">
                                                <div className="btn-wrapper text-center mt-0 go-top">
                                                    <Link to={`${routes.product}?${buildQueryParams()}`} className="btn theme-btn-4 text-uppercase improved-btn">Buscar</Link>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchForm;